require('dotenv').config();
/* eslint-disable max-len */

export const port = process.env.PORT;
export const host = `localhost:${port}`;
export const url = process.env.SITE_URL;
export const socketUrl = process.env.SOCKET_URL;
export const socketPort = process.env.SOCKET_PORT;
export const apiUrl = process.env.API_URL;
export const environment = false;

export const placeDetailURL = process.env.PLACE_DETAILS_URL;
export const autoCompleteURL = process.env.PLACES_AUTOCOMPLETE_URL;

export const fileuploadDir = process.env.FILEUPLOAD_DIR; // Listing Photos Upload Directory
export const homelogouploadDir = process.env.LOGOUPLOAD_DIR || './images/homeLogo/'; // Home Logo upload directory
export const banneruploadDir = process.env.BANNER_UPLOAD_DIR; // Home page Banner upload directory
export const profilePhotouploadDir = process.env.PROFILE_PHOTO_UPLOAD_DIR; // User Profile Photos Upload Directory
export const documentuploadDir = process.env.DOCUMENT_UPLOAD_DIR; //Document Upload
export const locationuploadDir = process.env.LOCATION_UPLOAD_DIR; // Location upload directory
export const homebanneruploadDir = process.env.HOME_BANNER_UPLOAD_DIR; // Homepage images
export const claimImagesUploadDir = process.env.CLAIM_IMAGES_UPLOAD_DIR; // claim images
export const faviconUploadDir = process.env.FAVICON_UPLOAD_DIR; //favicon dir
export const whyHostUploadDir = process.env.WHYHOST_UPLOAD_DIR; // whyHostUploadDir	
export const logouploadDir = process.env.LOGOUPLOAD_DIR; // Logo upload directory
export const ogImageuploadDir = process.env.OGIMAGEUPLOAD_DIR; // OG Image Upload directory
export const servicePlansUploadDir = process.env.SERVICE_PLANS_UPLOAD_DIR; //service plans image upload directory


export const analytics = {  // https://analytics.google.com/
  google: { trackingId: 'UA-XXXXX-X' },
};

export const locales = ['en-US', 'es', 'it-IT', 'fr-FR', 'pt-PT', 'ar']; // default locale is the first one
export const availableListSettings = [1, 20, 3, 4, 10, 21, 14, 15, 18, 19];

export const payment = {
  paypal: {
    returnURL: `${url}${process.env.PAYPAL_RETURN_URL}`,
    cancelURL: `${url}${process.env.PAYPAL_CANCEL_URL}`,
    redirectURL: {
      success: `${url}${process.env.PAYPAL_SUCCESS_REDIRECT_URL}`,
      cancel: `${url}${process.env.PAYPAL_CANCEL_URL}`,
    },
    servicePlan: {
      returnURL: `${url}${process.env.PAYPAL_SERVICE_PLANS_RETURN_URL}`,
      cancelURL: `${url}${process.env.PAYPAL_SERVICE_PLANS_CANCEL_URL}`,
      redirectURL: {
        success: `${url}${process.env.PAYPAL_SERVICE_PLANS_REDIRECT_URL}`,
      },
    },
    versions: {
      versionOne: '/v1',
      versionTwo: '/v2'
    },
    token_url: '/oauth2/token',
    payment_url: '/checkout/orders',
    capture_url: '/capture',
    payout_url: '/payments/payouts',
    refund: '/refund',
    refund_capture: '/payments/captures/'
  },

};

export const auth = {
  redirectURL: {
    login: '/dashboard',
    verification: '/user/verification',
    userbanned: '/userbanned',
    returnURLDeletedUser: '/userbanned'
  },
  google: { // https://cloud.google.com/console/project
    returnURL: `${url}/login/google/return`,
  }
};

export const dateFormat = {
  shortDateFormat: process.env.SHORT_DATE_FORMAT,
  usDateFormat: process.env.US_DATE_FORMAT,
  monthDayFormat: process.env.MONTH_DAY_FORMAT,
  monthYearFormat: process.env.MONTH_YEAR_FORMAT,
  fullMonthYearFormat: process.env.FULL_MONTH_YEAR_FORMAT,
  mediumDateFormat: process.env.MEDIUM_DATE_FORMAT,
  fullMonthDateFormat: process.env.FULL_MONTH_DATE_FORMAT,
  dayFullMonthFormat: process.env.DAY_FULL_MONTH_FORMAT,
  ordinalFullMonthFormat: process.env.ORDINAL_FULL_MONTH_FORMAT,
  displayDateFormat: process.env.DISPLAY_DATE_FORMAT,
  longDateFormat: process.env.LONG_DATE_FORMAT,
  fullDateFormat: process.env.FULL_DATE_FORMAT,
}
export const manageAndroidMobileLanguage = process.env.MANAGE_ANDROID_MOBILE_LANGUAGE
export const manageiOSMobileLanguage = process.env.MANAGE_IOS_MOBILE_LANGUAGE
export const manageFlutterMobileLanguage = process.env.MANAGE_FLUTTER_MOBILE_LANGUAGE
